import { getOrders } from '../../../HttpRequests/orders'
import { loadOrders } from '../State/project'
import { setFetching } from '../State/fetching'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { id } = getProps().match.params

  const params = {
    'filter[project_id]': id,
    include: 'project',
  }

  dispatch(setFetching(true))

  try {

    const response = await getOrders({ id, params })

    dispatch(loadOrders(response.data.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(setFetching(false))

  }

}
